module.exports = __webpack_public_path__ + "components/MapControl/svg/Szpital.svg?0cdf3b5a";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szpital.svg
// module id = 2036
// module chunks = 0